@let isDesktop = $isDesktop();
@let request = $request();

@if (request) {
  @if ($isWorkflowRoute()) {
    <router-outlet></router-outlet>
  } @else {
    <section class="content-wrap">
      <div
        class="x-card x-card_size_m px-0 md:mb-3"
        [ngClass]="{
          'bg-inherit before:hidden!': !isDesktop,
          'rounded-t-none bg-(--tui-background-base-alt) desktop-width-limit mx-auto island-without-top-border':
            isDesktop,
        }"
      >
        @if (!isDesktop) {
          <tui-tabs
            underline="transparent"
            [(activeItemIndex)]="tabIndex"
            class="x-mobile-tabs"
          >
            @for (tab of tabs; track tab) {
              <button
                tuiTab
                routerLinkActive="active-tab"
                [routerLink]="[tab]"
                replaceUrl="true"
              >
                <span class="typo-body-s font-medium">{{
                  'request_form.tabs.' + RequestFormTabTitlesTranslateKeys[tab]
                    | translate
                }}</span>
              </button>
            }
          </tui-tabs>
        }

        <router-outlet></router-outlet>
      </div>
    </section>
    @if (!isDesktop) {
      <x-app-version
        class="block h-[87px] w-full absolute bottom-[5px] px-14"
      />
    }
  }
} @else {
  <section
    class="w-full h-[calc(100vh-var(--x-desktop-header-height))] flex"
    [ngClass]="{
      'h-[calc(100vh-var(--x-desktop-header-height))]': isDesktop,
      'h-[calc(100vh-var(--x-mobile-header-height))]': !isDesktop,
    }"
  >
    <div
      tuiCardLarge
      tuiHeader
      appearance="floating"
      class="m-auto flex! items-center!"
    >
      <h1 tuiTitle>{{ 'request_form.loading' | translate }}</h1>
      <aside tuiAccessories>
        <tui-loader
          class="inline-flex min-w-11!"
          [inheritColor]="true"
          [size]="isDesktop ? 'l' : 'm'"
        ></tui-loader>
      </aside>
    </div>
  </section>
}

<!-- Хост PDF viewer — рендерится внутри tui-root, POLYMORPHEUS_CONTEXT доступен.
     Используется для просмотра PDF в контексте заявки (Открыть PDF, Е-ПТС). -->
<x-pdf-viewer-dialog></x-pdf-viewer-dialog>
